module.exports = __webpack_public_path__ + "img/ball_1_black.79ac4134.png";